import IItemProps from './Items/IItemProps';
import IHasItemEventProps from './Items/IHasItemEventProps';
import mapItemToItemComponent from './Items/mapItemToItemComponent';
import React from 'react';
import IHasItemDataProps from './Items/IHasItemDataProps';
import IHasMetaDataModalProps from './Items/IHasMetaDataModalProps';
import IHasRefiDiscountEventProps from './Items/IHasRefiDiscountEventProps';
import { ICDV3ViewItem } from '../../ui-toolkit/cdItems/interfaces/ICDViewItem';

export const generateServicesSectionItems = (
  items: ICDV3ViewItem[],
  props: IItemProps & IHasItemEventProps<ICDV3ViewItem> & IHasRefiDiscountEventProps
) =>
  items.map((item) => {
    const ItemComponent = mapItemToItemComponent(item) as React.ComponentType<
      IItemProps &
        IHasItemDataProps<ICDV3ViewItem> &
        IHasItemEventProps<ICDV3ViewItem> &
        IHasMetaDataModalProps &
        IHasRefiDiscountEventProps
    >;
    return (
      <ItemComponent
        {...props}
        disableAutoExpand={!item.removable}
        key={item.id}
        data={item}
        showRemove={item.removable}
        showMove={item.movable}
      />
    );
  });
